/**
 * If an attendance record is a clock in (entry) or a clock out (exit).
 */
export enum AttendanceRecordType {
  Entry = 'entry',
  Exit = 'exit',
}
